var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.563 19c0-8.526 6.91-15.438 15.437-15.438 8.526 0 15.438 6.912 15.438 15.438S27.526 34.438 19 34.438 3.562 27.526 3.562 19zm18.015-6.202c-1.41-1.23-3.747-1.23-5.154 0a1.188 1.188 0 0 1-1.564-1.787c2.302-2.014 5.978-2.014 8.28 0 2.396 2.096 2.396 5.57 0 7.666-.4.35-.846.643-1.325.874-1.07.52-1.628 1.226-1.628 1.824v1.188a1.188 1.188 0 0 1-2.375 0v-1.188c0-2.025 1.679-3.336 2.97-3.962.287-.139.555-.315.796-.524 1.314-1.15 1.314-2.94 0-4.09zM19 28.5a1.188 1.188 0 1 0 0-2.375 1.188 1.188 0 0 0 0 2.375z",
    fill: "#F9581E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.4781e64880c0de36ae6a800cc1069403.svg";
export { ForwardRef as ReactComponent };